export default __webpack_public_path__ + "static/media/Group 3190@2x.a0db20f1.png";